import { type ReactNode, createContext, useContext } from 'react';
import { sqWorkbookStore } from '@/core/core.stores';
import { useFluxPath } from '@/core/hooks/useFluxPath.hook';

export const WorkbookIsTopicContext = createContext<boolean>(false);

export const WorkbookIsTopicProvider = ({ children }: { children: ReactNode }) => {
  const isTopic = useFluxPath(sqWorkbookStore, () => sqWorkbookStore.isTopic);
  return <WorkbookIsTopicContext.Provider value={isTopic}>{children}</WorkbookIsTopicContext.Provider>;
};

export const useWorkbookIsTopic = (): boolean => useContext(WorkbookIsTopicContext);
